import {KTIcon} from '../../../../../../../_metronic/helpers'

interface IListSearchContract {
  searchContract: string
  setSearchContract: (value: string) => void
}
const ListSearchContract = ({searchContract, setSearchContract}: IListSearchContract) => {
  return (
    <>
      <div className='mb-5'>
        <label className='form-label fs-6 fw-bold'>Pesquisar Por Número De Contrato:</label>
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='number'
            data-kt-user-table-filter='contract'
            className='form-control form-control-solid min-w-250px ps-14'
            placeholder='Informe o número do contrato'
            value={searchContract}
            onChange={(e) => {
              setSearchContract(e.target.value)
            }}
          />
        </div>
      </div>
    </>
  )
}

export {ListSearchContract}
